import { Component } from '@angular/core';

@Component({
  selector: 'app-current-itinerary',
  templateUrl: './current-itinerary.component.html',
  styleUrls: ['./current-itinerary.component.css']
})
export class CurrentItineraryComponent {

}
